<template>
    <div class="sell_goods">
        <div class="top_title fixed">出售物品</div>
        <sell-component :ItemName="detail.ItemName" :detail="detail" :min="min" :max="max" />
        <seamless-scroll :list1="baseEffect" :list2="NpProperty" v-if="baseEffect.length != 0 || NpProperty.length != 0"/>
        <div v-if="(detail.ItemDes&&Number(detail.ItemDes.dwCount)) <= 1" class="chu">
            <div class="num">
                <div class="p-item">
                    <div class="title">出售单价</div>
                    <div class="field">
                        <em>&yen;</em>
                        <van-field type="number" v-model="price" placeholder="请输入售价" />
                    </div>
                </div>
                <div class="p-item">
                    <div>出售数量</div>
                    <div>x1</div>
                </div>
                <div class="p-item">
                    <div class="fw">
                        <span>扣除服务费({{rate}}%)</span>
                        <span class="tips" @click="showServiceFee">?</span>
                    </div>
                    <div>¥{{(price*num*rate/100).toFixed(3)}}</div>
                </div>
                <div class="p-item">
                    <div class="title">预计收款</div>
                    <div>¥{{(price*num*(1-rate/100)).toFixed(3)}}</div>
                </div>
            </div>

            <el-button :loading="loading > 0" class="pay_btn" type="primary" @click="confirm(1)">出售</el-button>
        </div>
        <div v-else class="chu">
            <div class="num">
                <div class="p-item">
                    <div class="title">出售单价</div>
                    <div class="field">
                        <em>&yen;</em>
                        <van-field type="number" v-model="price" placeholder="请输入售价" />
                    </div>
                </div>
                <div class="p-item">
                    <div>出售数量</div>
                    <div class="field">
                        <div v-if="disabled">x{{num}}</div>
                        <van-field v-model="num"  placeholder="请输入数量" @blur="blur" v-else/>
                    </div>
                </div>
                <div class="p-item">
                    <div class="fw">
                        <span>扣除服务费({{rate}}%)</span>
                        <span class="tips" @click="showServiceFee">?</span>
                    </div>
                    <div>¥{{(price*num*rate/100).toFixed(3)}}</div>
                </div>
                <div class="p-item">
                    <div class="title">预计收款</div>
                    <div>¥{{(price*num*(1-rate/100)).toFixed(3)}}</div>
                </div>
            </div>

            <el-button :loading="loading > 0" class="pay_btn" type="primary" @click="confirm">出售</el-button>
        </div>
        <!-- <div class="check" v-if="detail.ItemDes&&Number(detail.ItemDes.dwCount) > 1">
            <el-checkbox v-model="agree">允许拆分(拆分后买家可选择任意数量购买，手续费最低0.001，买家购买单个0.001价格道具时，您将不会获得任何收益，请谨慎勾选)</el-checkbox>
        </div> -->
        <van-popup v-model="show" position="bottom" class="bottom_pop">
            <div class="close_btn" @click="closepop"></div>
            <div class="title">输入支付密码</div>
            <el-form class="box">
                <el-form-item class="pay_area">
                    <span class="pt"></span>
                    <span class="error" v-if="error != ''">{{ error }}</span>
                    <span class="pay_type"></span>
                </el-form-item>
                <el-form-item class="pwd_area flex center" style="background-color: #fff;" v-if="!showloading">
                    <div class="otpInputs">
                        <el-input v-model="psd" type="number" oninput="if(value.length > 6) value=value.slice(0, 6)"
                            class="psd_ipt">
                        </el-input>
                        <span class="code_list">{{ psd1 }}</span>
                        <span class="code_list">{{ psd2 }}</span>
                        <span class="code_list">{{ psd3 }}</span>
                        <span class="code_list">{{ psd4 }}</span>
                        <span class="code_list">{{ psd5 }}</span>
                        <span class="code_list last_code_list">{{ psd6 }}</span>
                    </div>
                </el-form-item>
                <el-form-item class="pwd_area pwd_area2 flex center" style="background-color: #fff;" v-else>
                    <van-loading type="spinner" size="2rem" />
                    <div class="ing">上架中</div>
                </el-form-item>
            </el-form>
        </van-popup>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        data() {
            return {
                number: 0, //剩余数量
                price: "", //出售价格
                num: "", //出售数量
                agree: true,
                loading: 0,
                detail: {},
                baseEffect: [],
                NpProperty: [],
                min: 0, //最低价格
                max: 0, //最高价格
                show: false, //输入支付密码弹框
                psd: '',
                psd1: "",
                psd2: "",
                psd3: "",
                psd4: "",
                psd5: "",
                psd6: "",
                error: '',
                showloading: false,
                rate: '',
                disabled: true,
                rateList: [],
            };
        },
        computed: {
            params() {
                return {
                    app_id: this.$store.state.gameId,
                    server_id: this.$store.state.server_id,
                    server_name: this.$store.state.server_name,
                    role_id: this.$store.state.role_id,
                    role_name: this.$store.state.role_name,
                    item_id: this.$route.query.transaction_id,
                    account_id: this.$store.state.ac_id
                }
            },
            prop_id() {
                return this.$route.query.prop_id
            },
            transaction_id() {
                return this.$route.query.transaction_id
            }
        },
        mounted() {
            this.getGoodsDetail()
            this.getMax()
            this.getRateList()
        },
        methods: {
            showServiceFee() {
                this.$RModal.servicefee({
                    noheader: true,
                    selection: {
                        rateList: this.rateList
                    }
                })
            },
            blur() {
                if(this.num < 1) {
                    this.num = 1
                }
                if(this.num > this.detail.ItemDes.dwCount) {
                    this.num = this.detail.ItemDes.dwCount
                }
            },
            getGoodsDetail() {
                this.$Ajax('goods/detail', this.params, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.detail = rs.data
                        this.num = rs.data.ItemDes.dwCount
                        this.rate = parseInt(rs.data.rate)
                        if(rs.data.ItemDes.baseEffect) {
                            this.baseEffect = rs.data.ItemDes.baseEffect
                        }
                        if(rs.data.ItemDes.NpProperty) {
                            this.NpProperty = rs.data.ItemDes.NpProperty
                        }
                        if(rs.data.is_disable == 1) {
                            this.disabled = false
                        }
                    } else {
                        if (this.$store.state.role_id == '' || this.$store.state.role_id == undefined) {
                            this.$RModal.bindtips()
                        }
                    }
                })
            },
            getMax() {
                this.$Ajax('goods/find-price', {
                    prop_id: this.$route.query.prop_id,
                    server_id: this.params.server_id,
                    app_id: this.params.app_id
                }, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.min = rs.data.min
                        this.max = rs.data.max
                    }
                })
            },
            confirm(num) {
                if (this.$store.state.role_id == '' || this.$store.state.role_id == undefined) {
                    this.$RModal.bindtips()
                    return
                }
                if (num == 1) {
                    this.num = 1
                }
                if (this.price == '') {
                    this.$toast('请输入出售价格')
                    return
                } else {
                    if (Number(this.price) < Number(this.min)) {
                        this.$toast('出售价格不能低于' + this.min)
                        return
                    } else if (Number(this.price) > Number(this.max)) {
                        this.$toast('出售价格不能高于' + this.max)
                        return
                    }
                }
                if (this.num == '') {
                    this.$toast('请输入出售数量')
                    return
                }
                this.loading++
                this.$Ajax('pay-password/isset', {}, 'get').then(rs => {
                    if (rs.code == 200) {
                        if (rs.data.isset) {
                            this.error = ''
                            this.show = true
                            setTimeout(() => {
                                $('.pwd_area input').focus()
                            }, 100)
                        } else {
                            this.$RModal.tip({
                                selection: {
                                    title: '尚未设置支付密码，请先前往设置',
                                    btn: '前往设置'
                                },
                                onSuccess: () => {
                                    this.$router.push({
                                        name: 'user.password'
                                    })
                                }
                            })
                        }
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = 0
                    }, 2000)
                })
            },
            sell() {
                this.showloading = true
                this.$Ajax('goods/change-up', {
                    ...this.params,
                    item_name: this.detail.ItemName,
                    price: this.price,
                    stock: this.detail.ItemDes.dwCount,
                    num: this.num,
                    prop_id: this.detail.ItemDes.dwBaseID,
                    prop_name: this.detail.ItemName,
                    password: this.psd,
                    is_split: this.agree?'1':'0'
                }).then(rs => {
                    if (rs.code == 200) {
                        this.$router.push({
                            name: 'sell.success'
                        })
                    } else {
                        this.psd = ''
                        this.error = rs.msg
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.showloading = false
                    }, 3000)
                    setTimeout(() => {
                        $('.pwd_area input').focus()
                    }, 3100)
                })
            },
            closepop() {
                this.show = false
            },
            getRateList() {
                this.$Ajax('prop/rate-list', {
                    app_id: this.params.app_id
                }, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.rateList = rs.data
                        // const item = this.rateList.find(v => v.prop_id == this.prop_id)
                        // if (item) {
                        //     this.rate2 = item.rate
                        // }
                    }
                })
            }
        },
        watch: {
            psd: {
                immediate: true,
                handler(val) {
                    let arr = val.split("");
                    this.psd1 = arr[0];
                    this.psd2 = arr[1];
                    this.psd3 = arr[2];
                    this.psd4 = arr[3];
                    this.psd5 = arr[4];
                    this.psd6 = arr[5];
                    if (val.length == 6) {
                        this.sell()
                    }
                }
            },
        }
    };
</script>

<style lang="less" scoped>
    .sell_goods {
        .pay_btn {
            margin: 1.2rem auto;
            display: block;
            padding: 0;
            width: 35.5rem;
            height: 3.9rem;
            font-size: 1.4rem;
            border-radius: 10rem;
        }

        .chu {
            width: 100%;
            height: 13.5rem;
            margin-top: 0.7rem;
            margin-bottom: 0.6rem;
            // background-color: #fff;

            .num {
                // display: flex;
                // justify-content: center;
                background-color: #fff;
                padding: 1.2rem 1rem;
                border-radius: 1rem;
                .p-item {
                    position: relative;
                    width: 100%;
                    height: 2.2rem;
                    margin-bottom: 1.5rem;
                    line-height: 1;
                    border-radius: 3rem;
                    padding: 0px 0.7rem;
                    // background-color: var(--innerbgc);
                    font-size: 1.3rem;
                    color: #999;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .field {
                        display: flex;
                        align-items: center;
                        em {
                            color: #000;
                            font-size: 1.2rem;
                            margin-right: 1rem;
                        }
                    }
                    .fw {
                        display: flex;
                        align-items: center;
                        .tips {
                            margin-left: .6rem;
                            width: 1.4rem;
                            height: 1.4rem;
                            display: inline-block;
                            text-align: center;
                            line-height: 1.4rem;
                            border-radius: 50%;
                            border: 1px solid #999;
                            color: #999;
                            font-size: 1.2rem;
                        }
                    }
                    /deep/ .van-cell {
                        width: 13.6rem;
                        height: 3rem;
                        line-height: 3rem;
                        padding: 0 1rem;
                        background-color: #f5f5f5;
                        border-radius: .5rem;
                        font-size: 1.4rem;
                    }
                    &:nth-child(1) {
                        .title {
                            font-size: 1.6rem;
                            color: #000;
                        }
                    }
                    &:nth-last-child(1) {
                        color: #EF4D3D;
                        .title {
                            color: #000;
                        }
                    }
                }
            }

            .zf {
                width: 100%;
                color: #babdc1;
                text-align: center;
                font-size: 0.8rem;
                p {
                    height: 1.2rem;
                    font-size: 1.2rem;
                }
            }

            .btn {
                width: 9.9rem;
                height: 2.8rem;
                margin: 0 auto;
                margin-top: 1.4rem;
                color: #fff;
                text-align: center;
                line-height: 2.8rem;
                border-radius: 15px;
                background-color: var(--fade);
                cursor: pointer;
            }
        }
    }
    .bottom_pop {
        height: 30rem;
        background-color: #f2f2f2;
        border-top-left-radius: 0.6rem;
        border-top-right-radius: 0.6rem;

        .close_btn {
            position: absolute;
            top: 1rem;
            right: 1rem;
            width: 1.8rem;
            height: 1.8rem;

            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 0.2rem;
                height: 2.4rem;
                background-color: var(--fade5);
            }

            &::before {
                transform: translate(-50%, -50%) rotate(45deg);
            }

            &::after {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }

        .title {
            padding: 1rem 1.2rem;
            font-size: 1.6rem;
            margin-bottom: 2rem;
        }

        .pay_area {
            /deep/.el-form-item__content {
                height: 4rem;
                position: relative;
                padding: 0 !important;

                .pt {
                    position: absolute;
                    left: 1.2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 1.4rem;
                }

                .error {
                    color: var(--red);
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 1.2rem;
                }

                .pay_type {
                    position: absolute;
                    right: 1.2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 1.4rem;
                }
            }
        }

        .box {
            margin: 0 1rem;

            .el-form-item {
                margin-bottom: 0;
                border-bottom: 1px solid #eee;

                i {
                    color: var(--warning);
                }
            }

            /deep/.el-form-item__content {
                display: flex;
                align-items: center;
                background-color: #fff;
                border-radius: 0.3rem;
                padding-left: 1.2rem;
                font-size: 1.4rem;

                .label {
                    width: 5rem;
                    font-size: 1.3rem;
                }

                .el-input {
                    flex: 1;
                    border: none;
                    outline: none;

                    input {
                        border: none;
                        outline: none;
                        text-align: start;
                        padding: 0;
                        font-size: 1.3rem;
                    }
                }

                .el-form-item__error {
                    left: 1rem;
                    right: unset;
                    z-index: 10;
                    top: 100%;
                }
            }
        }
    }

    .pwd_area {
        /deep/.van-loading {
            i {
                color: #aaa !important;

            }
        }
    }

    .pwd_area2 {
        padding-top: 0;

        /deep/.el-form-item__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .ing {
            height: 2rem;
            font-size: 1rem;
            margin-top: -1rem;
        }
    }
</style>